"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./theme.js").styled("div",{boxSizing:"border-box"});exports.Box=e;
